const COUNTRY_CODES = {
  uganda: '256',
  ug: '256',
  kenya: '254',
  ke: '254',
  tanzania: '255',
  tz: '255',
  rwanda: '250',
  rw: '250',
  burundi: '257',
  nigeria: '234',
  ghana: '233',
  'south africa': '27',
  'united states': '1',
  usa: '1',
  us: '1',
  'united kingdom': '44',
  uk: '44',
  india: '91',
  'united arab emirates': '971',
  uae: '971',
};

export const whatsappDigits = (raw, country) => {
  const value = String(raw || '').trim();
  if (!value) return '';
  const hasPlus = value.startsWith('+') || value.startsWith('00');
  let digits = value.replace(/\D+/g, '');
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (!digits) return '';
  if (hasPlus) return digits;
  if (digits.startsWith('0') && digits.length >= 9) {
    const cc = COUNTRY_CODES[String(country || '').trim().toLowerCase()] || '256';
    return `${cc}${digits.slice(1)}`;
  }
  return digits;
};

export const whatsappUrl = (raw, { country, message } = {}) => {
  const digits = whatsappDigits(raw, country);
  if (!digits) return '';
  const base = `https://wa.me/${digits}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};

export const listingWhatsapp = (property) =>
  String(
    property?.whatsapp ||
      property?.whatsapp_number ||
      property?.mobile ||
      ''
  ).trim();
